import { client } from 'src/enviroment/api/axios'
import { useMutation } from '@tanstack/react-query'
import { handleApiError } from 'src/enviroment/api/errorHandler'
import { Mutation } from '../index'
import { CreateSupportTicketBody, SupportTicketResponse } from 'src/types/support'

export const supportRouterKeys = {
  tickets: 'support.tickets',
  ticket: (id: string) => `support.ticket.${id}`,
} as const

export const supportRouter = {
  createTicket: {
    useMutation: (opts?: Mutation<CreateSupportTicketBody, SupportTicketResponse>) => {
      return useMutation({
        mutationFn: async ({ subject, description, file }: CreateSupportTicketBody) => {
          const formData = new FormData()
          formData.append('subject', subject)
          formData.append('description', description)

          if (file) {
            formData.append('file', file)
          }

          return (
            await client.post<SupportTicketResponse>('/support/help', formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
          ).data
        },
        onError: handleApiError,
        ...opts,
      })
    },
  },
}
